import { mergeStyleSets } from '@fluentui/react';
import { TextWithTooltip } from '@v2/components/controls/TextWithTootip/TextWithTooltip';
import classes from 'classnames';
import React, { PropsWithChildren, useLayoutEffect, useRef, useState } from 'react';

interface PropertyEditWithDynamicContentProps extends PropsWithChildren {
    label: string;
    tooltip: string;
    className?: string;
}

const getClassNames = (firstElementHeight?: number) => mergeStyleSets({
    container: {
        display: 'grid',
        gridTemplateColumns: 'auto 1fr',
        alignItems: 'start',
        gap: '8px',
    },
    labelContainer: {
        display: 'flex',
        alignItems: 'center',
        height: firstElementHeight ? `${firstElementHeight}px` : 'auto',
    },
    contentContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
        alignItems: 'stretch',
        width: '100%',
    },
});

export const PropertyEditWithDynamicContent: React.FC<PropertyEditWithDynamicContentProps> = ({
    tooltip,
    label,
    children,
    className
}) => {
    const contentRef = useRef<HTMLDivElement>(null);
    const [firstElementHeight, setFirstElementHeight] = useState<number | undefined>();

    useLayoutEffect(() => {
        if (contentRef.current) {
            const firstChild = contentRef.current.firstElementChild as HTMLElement;
            if (firstChild) {
                setFirstElementHeight(firstChild.offsetHeight);
            }
        }
    }, [children]);

    const styles = getClassNames(firstElementHeight);

    return (
        <div className={classes(styles.container, className)}>
            <div className={styles.labelContainer}>
                <TextWithTooltip tooltip={tooltip} text={label} />
            </div>
            <div ref={contentRef} className={styles.contentContainer}>{children}</div>
        </div>
    );
};
